export default __webpack_public_path__ + "static/media/tete94.3b73b2f1.png";